import React from "react";
import { ArrowRight } from "lucide-react";
import { CONCERNS, IMAGES } from "../../data";
import { Reveal, Eyebrow, H2 } from "./Typo";

export default function WaterConcerns() {
  return (
    <section data-testid="water-concerns" className="section-pad bg-[#F4F1E9]">
      <div className="container-hw grid lg:grid-cols-12 gap-14 lg:gap-10">
        <Reveal className="lg:col-span-5 lg:sticky lg:top-28 self-start">
          <Eyebrow>Understand your water</Eyebrow>
          <H2 className="mt-6">{CONCERNS.heading}</H2>
          <p className="mt-7 text-[1.05rem] leading-relaxed text-[#3E474B] max-w-md">{CONCERNS.sub}</p>
          <figure className="mt-12 hidden lg:block">
            <img src={IMAGES.streamDetail} alt="A clear mountain creek running over moss-covered stones" loading="lazy" className="w-full aspect-[4/5] object-cover" />
          </figure>
        </Reveal>

        <div className="lg:col-span-6 lg:col-start-7">
          <ol className="border-t border-[#D9D6CC]">
            {CONCERNS.items.map((c, i) => (
              <Reveal as="li" key={c.title} delay={i * 0.06} data-testid={`concern-${i}`} className="grid grid-cols-[3rem_1fr] md:grid-cols-[4.5rem_1fr] py-9 md:py-11 border-b border-[#D9D6CC]">
                <span className="font-heading text-xl text-[#8CAFC0] pt-1">0{i + 1}</span>
                <div>
                  <h3 className="font-heading text-[2rem] md:text-[2.4rem] leading-tight text-[#172B38]">{c.title}</h3>
                  <p className="mt-3 text-[1rem] leading-relaxed text-[#3E474B] max-w-md">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </ol>
          <Reveal className="mt-12 flex flex-wrap items-center gap-6">
            <a href="#schedule" data-testid="concerns-cta" className="btn-cta">Find Out What's in Your Water <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></a>
          </Reveal>
          <img src={IMAGES.streamDetail} alt="A clear mountain creek running over moss-covered stones" loading="lazy" className="mt-14 w-full aspect-[16/10] object-cover lg:hidden" />
        </div>
      </div>
    </section>
  );
}
